import React from "react";
import { Logo } from "./Logo";
import { Linkedin } from "lucide-react";

const FOOTER_LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Approach", href: "#approach" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Resources", href: "#resources" },
  { label: "Contact", href: "#contact" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0D0D0D] text-[#F9F8F6] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-14 border-b border-white/10">
          <div className="md:col-span-5">
            <Logo variant="light" />
            <p className="font-sans-body text-[15px] leading-relaxed text-white/70 mt-6 max-w-sm">
              Independent operational risk consultancy. Senior advisory for boards and executives who expect substance.
            </p>
          </div>
          <div className="md:col-span-4">
            <p className="font-sans-body text-[11px] tracking-widest-2 uppercase text-[#9CDBD9] mb-5">
              Navigate
            </p>
            <ul className="grid grid-cols-2 gap-y-3">
              {FOOTER_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                    className="font-sans-body text-sm text-white/80 hover:text-[#9CDBD9]"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-sans-body text-[11px] tracking-widest-2 uppercase text-[#9CDBD9] mb-5">
              Stay in touch
            </p>
            <a
              href="mailto:elena@theopriskcompany.com"
              data-testid="footer-email"
              className="block font-sans-body text-sm text-white/80 hover:text-[#9CDBD9] mb-3"
            >
              elena@theopriskcompany.com
            </a>
            <a
              href="https://www.linkedin.com/in/elenapykhova/"
              target="_blank"
              rel="noreferrer noopener"
              data-testid="footer-linkedin"
              className="inline-flex items-center gap-2 font-sans-body text-sm text-white/80 hover:text-[#9CDBD9]"
            >
              <Linkedin size={16} strokeWidth={1.4} /> LinkedIn
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8">
          <p className="font-sans-body text-xs text-white/50">
            © {new Date().getFullYear()} Elena Pykhova Consulting. All rights reserved.
          </p>
          <p className="font-sans-body text-xs text-white/50">
            Registered in England · UK based · Working globally
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
